import { FaCheckCircle, FaRegClock, FaShieldAlt } from "react-icons/fa";
import Footer from "./Footer";
import Navbar from "./Navbar";
import AboutIntro from "./AboutIntro";
import WhyChooseUs from "./WhyChooseUs";

const AboutUs = () => {
  return (
    <div className="min-w-screen bg-white">
      <Navbar />

      <div style={{ paddingTop: 130 }}>
        <AboutIntro />
      </div>

      <div className="w-full pt-16 pb-16 px-4" style={{ background: "#ffffff" }}>
        <main className="w-full max-w-4xl mx-auto flex flex-col gap-16">
          {/* Mission & Vision */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[
              {
                title: "Our Mission",
                desc: "Make debt consolidation quicker, simpler, and easily accessible for salaried and self-employed individuals. Empower people financially with easy and affordable access to credit through innovative technology.",
              },
              {
                title: "Our Vision",
                desc: "Create a transparent, customer-centric lending ecosystem providing credit access when it's needed the most. Leverage technology to promote financial inclusion for all.",
              },
            ].map((item) => (
              <div
                key={item.title}
                className="p-8 rounded-2xl transition-shadow duration-300"
                style={{
                  border: "1px solid #E6E6E7",
                  background: "#fff",
                  boxShadow: "0 4px 24px 0 rgba(249, 76, 9, 0.12)",
                }}
              >
                <h2
                  className="text-2xl font-['Inter'] font-[700] mb-4"
                  style={{ color: "#283AAA" }}
                >
                  {item.title}
                </h2>
                <p className="text-lg leading-relaxed font-['Inter'] font-[400]" style={{ color: "#404040" }}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          {/* Technology Section */}
          <div
            className="p-8 rounded-2xl transition-shadow duration-300"
            style={{
              border: "1px solid #E6E6E7",
              background: "#fff",
              boxShadow: "0 4px 24px 0 rgba(249, 76, 9, 0.12)",
            }}
          >
            <h2
              className="text-2xl font-['Inter'] font-[700] mb-6 text-center"
              style={{ color: "#283AAA" }}
            >
              Our Technology
            </h2>
            <p className="text-lg text-center mb-6 font-['Inter'] font-[400]" style={{ color: "#404040" }}>
              {import.meta.env.VITE_COMPANY_NAME} is powered by advanced algorithms and a fully
              digital platform, simplifying the loan process and providing accurate credit
              assessments instantly.
            </p>
            <ul className="list-none grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mx-auto">
              {[
                {
                  icon: <FaCheckCircle className="text-xl" style={{ color: "#032799" }} />,
                  text: "Quick and accurate credit assessments using advanced algorithms.",
                },
                {
                  icon: <FaRegClock className="text-xl" style={{ color: "#032799" }} />,
                  text: "Intuitive platform for smooth loan applications.",
                },
                {
                  icon: <FaShieldAlt className="text-xl" style={{ color: "#032799" }} />,
                  text: "Secure and encrypted transactions ensuring data safety.",
                },
                {
                  icon: <FaCheckCircle className="text-xl" style={{ color: "#032799" }} />,
                  text: "Track your loan application status in real-time.",
                },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  {item.icon}
                  <span className="font-['Inter'] font-[400]" style={{ color: "#404040" }}>
                    {item.text}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </main>
      </div>

      <WhyChooseUs />
      <Footer />
    </div>
  );
};

export default AboutUs;
